'use client';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import Button from '@repo/ui/src/components/Button';
import FilterAccordion from './_FilterAccordion';

const FilterDrawer = ({ open, onClose, filters, currentFilters, setFilters, clearFilters }) => {
  return (
    <Drawer open={open} onClose={onClose}>
      <Box display="flex" justifyContent="flex-end" pb={2}>
        <IconButton
          data-dismiss="modal"
          aria-label="Close"
          size="large"
          onClick={onClose}
          sx={{ borderRadius: 0 }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box px={4} pt={4} pb={1} sx={{ minWidth: '300px' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography component="h2" variant="h5">
            Filters
          </Typography>
          <Button
            onClick={() => clearFilters()}
            variant="bare"
            size="small"
            className="tw-text-action-400"
          >
            Clear All
          </Button>
        </Box>
        {filters?.map((filter, i) => (
          <FilterAccordion
            currentFilters={currentFilters}
            setFilters={setFilters}
            key={`filter_accordion_${i}`}
            filter={filter}
            index={i}
          />
        ))}
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
